import { Type } from 'class-transformer';
import { IsNumber, IsOptional } from 'class-validator';
import { AbstractInterface } from './abstract.interface';

export class AbstractModel implements AbstractInterface {

    @IsNumber()
    @IsOptional()
    @Type(() => Number)
    _id?: number;

    _version: number = 0;

    _createdBy: number = 0;

    _updatedBy?: number;

    @Type(() => Date)
    _createdAt: Date = new Date();

    @Type(() => Date)
    _updatedAt?: Date;
}
